import _ from "lodash";
import { compareNotifications, priorityValues, processNotificationPayload } from "./notificationsUtils";

const defaultTypeFilter = {
    values:{
        critical:true
    }
}

const defaultState = () => ({
    typeFilter: defaultTypeFilter,
    servicesFilter: {},
    notifications: []
});



function dismissSingleMessage(notifications,notificationIdToDismiss) {
    return notifications.filter(n => n.id !== notificationIdToDismiss);
}

export default (state = defaultState(), { type, payload }) => {
    switch (type) {
        case "UI-NOTIFICATIONS:DISMISS-ONE-SUCCESS": {
            const notifications =  dismissSingleMessage(state.notifications,payload?.data?.id)
            const highestPriority = _.maxBy(notifications, n => priorityValues[n.priority])?.priority;

            return { ...state, notifications, highestPriority }
        }
        case "UI-NOTIFICATIONS:DISMISS-ALL-PENDING": {
            return { ...state, isDismissingAll: true }
        }
        case "UI-NOTIFICATIONS:DISMISS-ALL-SUCCESS": {
            return { ...state, notifications: [], isDismissingAll: false, highestPriority: undefined }
        }
        case "UI-NOTIFICATIONS:DISMISS-ALL-ERROR": {
            return { ...state, isDismissingAll: false }
        }

        case "UI-NOTIFICATIONS:SET-FILTER": {
            let key = payload.id;
            const { values } = payload;
            const filter = `${key}Filter`;
            return {
                ...state, [filter]: {
                    values: key === "type" ?  {...values, critical:true} : values,
                    activeCount: _.sumBy(_.values(values), v => {
                        return v ? 1 : 0;
                    })
                }
            }
        }
        case "UI-NOTIFICATIONS:CLEAR-FILTERS": {
            return { ...state, typeFilter:defaultTypeFilter, servicesFilter: {} }
        }

        case "UI-NOTIFICATIONS:MESSAGE-RECEIVED": {
            console.debug(payload);
            const processedNotification = processNotificationPayload(payload);
            
            const notifications =
                [
                    ...(processedNotification ? [processedNotification] : []),
                    ...state.notifications
                ];
            
            const highestPriority = _.maxBy(notifications, n => priorityValues[n.priority])?.priority;

            return { ...state, notifications: notifications.sort(compareNotifications), highestPriority }

        }

        case "UI-NOTIFICATIONS:WORKER-PROCESSED-NOTIFICATIONS": {
            const notifications = payload.notifications || [];
            const highestPriority = payload.highestPriority;

            return {
                ...state,
                notifications,
                highestPriority,
            };
        }

        default: {
            return state;
        }
    }
};
